import { BottomModal } from "components/common/BottomModal/BottomModal";
import { SKIP_TOUCH_ID_BOTTOM_MODAL } from "components/common/BottomModal/useBottomModal";
import { CloseIcon } from "components/common/Icons/CloseIcon";
import { DeleteIcon } from "components/common/Icons/DeleteIcon";
import { Select } from "components/common/Select/Select";
import { Slider } from "components/common/Slider/Slider";
import { Translate } from "components/common/Translate/Translate";
import { getDefaultPaddingColors } from "store/features/memeGenerator/data/getDefaultPaddingColors";
import { paddingKeysList, paddingNamesObject } from "store/features/memeGenerator/data/paddingNames";
import { PaddingType } from "store/features/memeGenerator/types/padding";
import { usePadding } from "../../../LeftBar/Padding/usePadding";

interface PaddingProps {
    isOpen: boolean;
    close: () => void;
}

export const Padding = ({ isOpen, close }: PaddingProps) => {
    const { padding, dominantColor, handlePaddingOptionClick, handlePaddingColorClick, handlePaddingValue } =
        usePadding();
    return (
        <BottomModal isOpen={isOpen} onClose={close} titleBar={<TitleBar close={close} />}>
            <div className="px-6 py-3 flex flex-col gap-4 text-black dark:text-white">
                <div className="flex items-center justify-between gap-2">
                    <div className="w-full">
                        <Select
                            options={paddingKeysList}
                            getOptionLabel={(key) => paddingNamesObject[key]}
                            getOptionValue={(key) => key}
                            value={padding?.type}
                            handleClick={handlePaddingOptionClick}
                        />
                    </div>
                    <div className="w-full">
                        <Select
                            options={getDefaultPaddingColors(dominantColor ?? "#000")}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.color}
                            value={padding?.color}
                            handleClick={handlePaddingColorClick}
                        />
                    </div>
                </div>
                <div className="flex items-stretch gap-2">
                    <div className="flex items-center gap-4 border border-irGray-200 dark:border-darkSurface-400 px-4 pt-2 pb-3 rounded-xl flex-grow">
                        <div className="flex-grow">
                            <Slider
                                min={0}
                                max={100}
                                defaultValue={padding?.value || 0}
                                handleChange={handlePaddingValue}
                                step={1}
                            />
                        </div>
                        <div className="mt-1">{padding?.value}%</div>
                    </div>
                    <button
                        className="group flex items-center justify-center px-4 border border-irGray-200 dark:border-darkSurface-400 rounded-xl hover:bg-irRed-400"
                        onClick={() => {
                            handlePaddingOptionClick(PaddingType.NONE);
                            close();
                        }}
                    >
                        <DeleteIcon className="fill-irRed-400 group-hover:fill-white" />
                    </button>
                </div>
            </div>
        </BottomModal>
    );
};

interface TitleBarProps {
    close: () => void;
}

function TitleBar({ close }: TitleBarProps) {
    return (
        <div className="relative flex items-center justify-center py-2 text-black dark:text-white">
            <div className="text-lg capitalize">
                <Translate keyName="padding" />
            </div>
            <div className="absolute right-4 top-0 bottom-0 grid place-items-center">
                <div
                    className="w-6 h-6 bg-irGray-300 dark:bg-darkSurface-200 rounded-full grid place-items-center"
                    onClick={close}
                    id={SKIP_TOUCH_ID_BOTTOM_MODAL}
                >
                    <CloseIcon />
                </div>
            </div>
        </div>
    );
}
